import { render, staticRenderFns } from "./MainPerformance.vue?vue&type=template&id=c3d89284&scoped=true"
import script from "./MainPerformance.vue?vue&type=script&lang=js"
export * from "./MainPerformance.vue?vue&type=script&lang=js"
import style0 from "./MainPerformance.vue?vue&type=style&index=0&id=c3d89284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d89284",
  null
  
)

export default component.exports